import { QueryResultCallback } from "../../models/Callback/Callback";
import { TUserAttr, TUserData, TUserNotfSettingsAttr, User } from "../../models/User/User";
import { UserStoreActions } from "../../redux/services/user/actions";
import { APIManager } from "../APIManager";
import { DealerGroupManager } from "../DealerGroupManager/DealerGroupManager";
import { OrgManager } from "../OrgManager/OrgManager";
import { UserNetworkHelper } from "./NetworkHelper";

export class UserManager {
    networkHelper = UserNetworkHelper;
    private newUserObj(data: TUserAttr) {
        return new User(data);
    }
    async apiFetchUserData(cb: QueryResultCallback<TUserData>) {
        try {
            UserStoreActions.loadingUser(true);
            const resp = await APIManager.get(APIManager.USER_DATA_API);
            const userData: TUserData = resp.data;
            UserStoreActions.saveUser(this.newUserObj(userData.userInfo));

            new OrgManager().saveUserOrganizations([...userData.orgs.owned, ...userData.orgs.membership]);
            new DealerGroupManager().saveUserOrganizations([...userData.dealerGroups.owned, ...userData.dealerGroups.membership]);

            cb(null, userData);
        } catch (err) {
            cb(`${err}`);
        } finally {
            UserStoreActions.loadingUser(false);
        }
    }
    getActiveUser() {
        return UserStoreActions.getUser();
    }
}
